import uniqid from 'uniqid'
import useAppState from '@/hooks/appState'

const toastLifespan = 2000

export default function useToast () {
  const appState = useAppState()

  return (message) => {
    appState.toasts.push({
      id: uniqid(),
      message,
      aliveFor: appState.toasts.length ? (toastLifespan / 2) : toastLifespan
    })
  }
}
